import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col, Input, InputGroup, InputGroupText, Row } from 'reactstrap';
import { isEqual } from 'lodash';
import queryString from 'query-string';
import { FlashMessageContext } from 'contexts/FlashMessageContext';
import { resetPassword } from "utils/api";
import { AuthContext } from 'contexts/AuthContext';
import { SpinnerButton } from 'common/SpinnerButton';
import Logo from 'images/logo.png';
import {InputWithError} from "../../common/InputWithError";
import {AuthLayout} from "./AuthLayout";

export const ResetPassword = () => {
    const navigate = useNavigate();
    const queryParams = useLocation();
    const { addFlashMessage } = useContext(FlashMessageContext);
    const { signIn, state, logout } = useContext(AuthContext);

    const [submitting, setSubmitting] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [newToken, setNewToken] = useState(null);
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        if (state.token) {
            logout();
        }
    }, []);

    useEffect(() => {
        if (newToken && isEqual(state.tokenData, newToken)) {
            navigate('/');
        }
    }, [state.tokenData, newToken]);

    useEffect(() => {
        setErrors(null);
    }, [password, confirmPassword]);

    const onSubmit = async () => {
        setSubmitting(true);

        try {
            const params = {
                confirmation_token: queryString.parse(queryParams.search)?.token,
                password: password,
                confirm_password: confirmPassword
            };

            const res = await resetPassword(params);

            // addFlashMessage('success', 'Password successfully changed');

            signIn(res?.dpb_token);
            setNewToken(res?.dpb_token);
        } catch (err) {
            setErrors({errors: {'plainPassword': [{'message': err}]}});
        }

        setSubmitting(false);
    };

    const ResetPasswordForm = () => {
        return (
            <div className="d-flex justify-content-center align-items-center flex-grow-1">
                <div className="text-center w-100 px-3 px-md-5">
                    <div className="login-box shadow-sm">
                        <h4 className="mb-5 login-title">Reset Password</h4>
                        <div className="mb-3 text-start">
                            <label htmlFor="password" className="form-label">Password (Min 6 Characters)</label>
                            <InputWithError
                                id="password"
                                name="password"
                                value={password}
                                type="password"
                                onChange={setPassword}
                                errorObj={errors}
                                autoComplete="off"
                                marginBottomClass="mb-3"
                                className="rounded-pill"
                            />
                        </div>
                        <div className="mb-3 text-start">
                            <label htmlFor="confirm-password" className="form-label">Confirm Password</label>
                            <InputWithError
                                id="confirm-password"
                                name="plainPassword"
                                value={confirmPassword}
                                type="password"
                                onChange={setConfirmPassword}
                                errorObj={errors}
                                autoComplete="off"
                                marginBottomClass="mb-5"
                                className="rounded-pill"
                            />
                        </div>
                        <div className="d-grid mb-4">
                            <SpinnerButton
                                color="primary"
                                block
                                disabled={password.length < 5 && confirmPassword.length < 5}
                                onClick={onSubmit}
                                submitting={submitting}
                                title="Save new password"
                                className="text-bold rounded-pill"
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return <AuthLayout authForm={ResetPasswordForm()}/>
};
